import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-best-practices', templateUrl: './best-practices.component.html', styleUrls: ['./best-practices.component.scss'] })
export class BestPracticesComponent implements OnInit { constructor() { } ngOnInit(): void { } }
